var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"article"},[_c('div',{staticClass:"content"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.detail.content)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }